var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","overflow-y":"auto","overflow-x":"hidden"}},[_c('div',{attrs:{"id":"printBox"}},[_c('reportContent',{ref:"reportContent"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }